const danger_bins =
  {
    "1001": 4,
    "1003": 5,
    "1005": 4,
    "1007": 3,
    "1009": 4,
    "1011": 3,
    "1013": 4,
    "1015": 4,
    "1017": 3,
    "1019": 3,
    "1021": 4,
    "1023": 4,
    "1025": 4,
    "1027": 3,
    "1029": 3,
    "1031": 5,
    "1033": 4,
    "1035": 4,
    "1037": 3,
    "1039": 4,
    "1041": 4,
    "1043": 5,
    "1045": 4,
    "1047": 4,
    "1049": 5,
    "1051": 4,
    "1053": 4,
    "1055": 4,
    "1057": 4,
    "1059": 3,
    "1061": 4,
    "1063": 4,
    "1065": 4,
    "1067": 4,
    "1069": 4,
    "1071": 5,
    "1073": 5,
    "1075": 4,
    "1077": 5,
    "1079": 5,
    "1081": 4,
    "1083": 5,
    "1085": 4,
    "1087": 4,
    "1089": 5,
    "1091": 4,
    "1093": 5,
    "1095": 5,
    "1097": 5,
    "1099": 4,
    "1101": 4,
    "1103": 5,
    "1105": 4,
    "1107": 5,
    "1109": 3,
    "1111": 3,
    "1113": 4,
    "1115": 5,
    "1117": 4,
    "1119": 4,
    "1121": 4,
    "1123": 4,
    "1125": 5,
    "1127": 4,
    "1129": 4,
    "1131": 4,
    "1133": 4,
    "2013": 0,
    "2016": 2,
    "2020": 1,
    "2050": 1,
    "2060": 0,
    "2068": 3,
    "2070": 0,
    "2090": 0,
    "2100": 0,
    "2110": 0,
    "2122": 2,
    "2130": 0,
    "2150": 1,
    "2164": 2,
    "2170": 2,
    "2180": 2,
    "2185": 3,
    "2188": 2,
    "2201": 0,
    "2220": 1,
    "2232": 0,
    "2240": 1,
    "2261": 2,
    "2270": 0,
    "2280": 0,
    "2282": 1,
    "2290": 2,
    "4001": 2,
    "4003": 2,
    "4005": 5,
    "4007": 2,
    "4009": 1,
    "4011": 0,
    "4012": 0,
    "4013": 3,
    "4015": 3,
    "4017": 3,
    "4019": 3,
    "4021": 2,
    "4023": 1,
    "4025": 2,
    "4027": 0,
    "5001": 3,
    "5003": 3,
    "5005": 3,
    "5007": 4,
    "5009": 2,
    "5011": 2,
    "5013": 3,
    "5015": 2,
    "5017": 3,
    "5019": 4,
    "5021": 3,
    "5023": 2,
    "5025": 2,
    "5027": 3,
    "5029": 4,
    "5031": 3,
    "5033": 4,
    "5035": 1,
    "5037": 3,
    "5039": 3,
    "5041": 2,
    "5043": 3,
    "5045": 4,
    "5047": 4,
    "5049": 2,
    "5051": 4,
    "5053": 3,
    "5055": 3,
    "5057": 3,
    "5059": 4,
    "5061": 3,
    "5063": 3,
    "5065": 3,
    "5067": 3,
    "5069": 3,
    "5071": 3,
    "5073": 2,
    "5075": 2,
    "5077": 2,
    "5079": 3,
    "5081": 2,
    "5083": 3,
    "5085": 4,
    "5087": 3,
    "5089": 2,
    "5091": 2,
    "5093": 3,
    "5095": 3,
    "5097": 3,
    "5099": 3,
    "5101": 2,
    "5103": 3,
    "5105": 3,
    "5107": 2,
    "5109": 3,
    "5111": 2,
    "5113": 3,
    "5115": 3,
    "5117": 3,
    "5119": 5,
    "5121": 3,
    "5123": 2,
    "5125": 5,
    "5127": 2,
    "5129": 2,
    "5131": 4,
    "5133": 2,
    "5135": 3,
    "5137": 3,
    "5139": 3,
    "5141": 4,
    "5143": 3,
    "5145": 4,
    "5147": 3,
    "5149": 3,
    "6001": 1,
    "6003": 1,
    "6005": 1,
    "6007": 2,
    "6009": 1,
    "6011": 1,
    "6013": 1,
    "6015": 0,
    "6017": 3,
    "6019": 2,
    "6021": 1,
    "6023": 1,
    "6025": 1,
    "6027": 3,
    "6029": 3,
    "6031": 0,
    "6033": 0,
    "6035": 1,
    "6037": 4,
    "6039": 0,
    "6041": 1,
    "6043": 0,
    "6045": 0,
    "6047": 1,
    "6049": 0,
    "6051": 2,
    "6053": 2,
    "6055": 2,
    "6057": 3,
    "6059": 2,
    "6061": 3,
    "6063": 2,
    "6065": 5,
    "6067": 2,
    "6069": 0,
    "6071": 5,
    "6073": 5,
    "6075": 0,
    "6077": 1,
    "6079": 2,
    "6081": 1,
    "6083": 1,
    "6085": 3,
    "6087": 1,
    "6089": 2,
    "6091": 2,
    "6093": 2,
    "6095": 1,
    "6097": 3,
    "6099": 1,
    "6101": 1,
    "6103": 2,
    "6105": 0,
    "6107": 1,
    "6109": 1,
    "6111": 2,
    "6113": 0,
    "6115": 2,
    "8001": 3,
    "8003": 2,
    "8005": 4,
    "8007": 2,
    "8009": 3,
    "8011": 2,
    "8013": 4,
    "8014": 1,
    "8015": 1,
    "8017": 3,
    "8019": 2,
    "8021": 1,
    "8023": 2,
    "8025": 0,
    "8027": 2,
    "8029": 4,
    "8031": 2,
    "8033": 2,
    "8035": 3,
    "8037": 3,
    "8039": 4,
    "8041": 5,
    "8043": 3,
    "8045": 3,
    "8047": 1,
    "8049": 1,
    "8051": 3,
    "8053": 2,
    "8055": 3,
    "8057": 1,
    "8059": 2,
    "8061": 3,
    "8063": 4,
    "8065": 0,
    "8067": 3,
    "8069": 4,
    "8071": 4,
    "8073": 3,
    "8075": 3,
    "8077": 4,
    "8079": 2,
    "8081": 4,
    "8083": 2,
    "8085": 4,
    "8087": 3,
    "8089": 1,
    "8091": 2,
    "8093": 3,
    "8095": 2,
    "8097": 2,
    "8099": 3,
    "8101": 3,
    "8103": 3,
    "8105": 2,
    "8107": 3,
    "8109": 2,
    "8111": 1,
    "8113": 3,
    "8115": 1,
    "8117": 0,
    "8119": 2,
    "8121": 4,
    "8123": 5,
    "8125": 4,
    "9001": 4,
    "9003": 3,
    "9005": 4,
    "9007": 3,
    "9009": 4,
    "9011": 3,
    "9013": 3,
    "9015": 2,
    "10001": 3,
    "10003": 4,
    "10005": 4,
    "11001": 4,
    "12001": 4,
    "12003": 3,
    "12005": 5,
    "12007": 3,
    "12009": 5,
    "12011": 5,
    "12013": 4,
    "12015": 4,
    "12017": 4,
    "12019": 4,
    "12021": 5,
    "12023": 3,
    "12027": 3,
    "12029": 2,
    "12031": 5,
    "12033": 5,
    "12035": 4,
    "12037": 4,
    "12039": 4,
    "12041": 1,
    "12043": 4,
    "12045": 4,
    "12047": 2,
    "12049": 3,
    "12051": 3,
    "12053": 3,
    "12055": 4,
    "12057": 5,
    "12059": 4,
    "12061": 4,
    "12063": 4,
    "12065": 3,
    "12067": 2,
    "12069": 5,
    "12071": 4,
    "12073": 4,
    "12075": 3,
    "12077": 3,
    "12079": 3,
    "12081": 4,
    "12083": 4,
    "12085": 4,
    "12086": 5,
    "12087": 4,
    "12089": 3,
    "12091": 4,
    "12093": 3,
    "12095": 5,
    "12097": 4,
    "12099": 5,
    "12101": 4,
    "12103": 4,
    "12105": 5,
    "12107": 4,
    "12109": 4,
    "12111": 4,
    "12113": 4,
    "12115": 4,
    "12117": 4,
    "12119": 4,
    "12121": 4,
    "12123": 4,
    "12125": 3,
    "12127": 5,
    "12129": 4,
    "12131": 4,
    "12133": 4,
    "13001": 3,
    "13003": 3,
    "13005": 3,
    "13007": 3,
    "13009": 2,
    "13011": 3,
    "13013": 2,
    "13015": 4,
    "13017": 2,
    "13019": 1,
    "13021": 3,
    "13023": 2,
    "13025": 2,
    "13027": 3,
    "13029": 3,
    "13031": 4,
    "13033": 3,
    "13035": 2,
    "13037": 3,
    "13039": 4,
    "13043": 3,
    "13045": 4,
    "13047": 4,
    "13049": 2,
    "13051": 4,
    "13053": 2,
    "13055": 2,
    "13057": 4,
    "13059": 1,
    "13061": 0,
    "13063": 3,
    "13065": 3,
    "13067": 4,
    "13069": 3,
    "13071": 3,
    "13073": 3,
    "13075": 3,
    "13077": 3,
    "13079": 3,
    "13081": 3,
    "13083": 3,
    "13085": 1,
    "13087": 3,
    "13089": 3,
    "13091": 3,
    "13093": 3,
    "13095": 4,
    "13097": 2,
    "13099": 3,
    "13101": 2,
    "13103": 3,
    "13105": 3,
    "13107": 3,
    "13109": 2,
    "13111": 2,
    "13113": 2,
    "13115": 4,
    "13117": 2,
    "13119": 3,
    "13121": 4,
    "13123": 3,
    "13125": 2,
    "13127": 3,
    "13129": 2,
    "13131": 4,
    "13133": 1,
    "13135": 3,
    "13137": 3,
    "13139": 3,
    "13141": 3,
    "13143": 3,
    "13145": 3,
    "13147": 2,
    "13149": 3,
    "13151": 3,
    "13153": 3,
    "13155": 2,
    "13157": 2,
    "13159": 2,
    "13161": 2,
    "13163": 3,
    "13165": 2,
    "13167": 3,
    "13169": 2,
    "13171": 2,
    "13173": 1,
    "13175": 4,
    "13177": 2,
    "13179": 3,
    "13181": 2,
    "13183": 3,
    "13185": 3,
    "13187": 3,
    "13189": 1,
    "13191": 4,
    "13193": 3,
    "13195": 3,
    "13197": 2,
    "13199": 3,
    "13201": 3,
    "13205": 3,
    "13207": 2,
    "13209": 3,
    "13211": 2,
    "13213": 2,
    "13215": 2,
    "13217": 3,
    "13219": 2,
    "13221": 1,
    "13223": 1,
    "13225": 3,
    "13227": 3,
    "13229": 3,
    "13231": 4,
    "13233": 3,
    "13235": 2,
    "13237": 2,
    "13239": 0,
    "13241": 3,
    "13243": 2,
    "13245": 3,
    "13247": 2,
    "13249": 2,
    "13251": 4,
    "13253": 3,
    "13255": 3,
    "13257": 1,
    "13259": 3,
    "13261": 3,
    "13263": 3,
    "13265": 1,
    "13267": 2,
    "13269": 3,
    "13271": 2,
    "13273": 2,
    "13275": 3,
    "13277": 2,
    "13279": 3,
    "13281": 2,
    "13283": 3,
    "13285": 3,
    "13287": 2,
    "13289": 3,
    "13291": 2,
    "13293": 3,
    "13295": 3,
    "13297": 2,
    "13299": 3,
    "13301": 2,
    "13303": 3,
    "13305": 3,
    "13307": 3,
    "13309": 2,
    "13311": 3,
    "13313": 2,
    "13315": 3,
    "13317": 3,
    "13319": 3,
    "13321": 4,
    "15001": 5,
    "15003": 4,
    "15005": 0,
    "15007": 4,
    "15009": 4,
    "16001": 0,
    "16003": 1,
    "16005": 1,
    "16007": 0,
    "16009": 1,
    "16011": 1,
    "16013": 0,
    "16015": 0,
    "16017": 1,
    "16019": 0,
    "16021": 1,
    "16023": 0,
    "16025": 0,
    "16027": 0,
    "16029": 1,
    "16031": 0,
    "16033": 0,
    "16035": 1,
    "16037": 0,
    "16039": 1,
    "16041": 0,
    "16043": 1,
    "16045": 1,
    "16047": 0,
    "16049": 1,
    "16051": 1,
    "16053": 0,
    "16055": 3,
    "16057": 1,
    "16059": 0,
    "16061": 0,
    "16063": 0,
    "16065": 0,
    "16067": 0,
    "16069": 0,
    "16071": 0,
    "16073": 1,
    "16075": 0,
    "16077": 1,
    "16079": 1,
    "16081": 0,
    "16083": 1,
    "16085": 0,
    "16087": 1,
    "17001": 3,
    "17003": 3,
    "17005": 2,
    "17007": 2,
    "17009": 2,
    "17011": 3,
    "17013": 2,
    "17015": 2,
    "17017": 1,
    "17019": 4,
    "17021": 3,
    "17023": 1,
    "17025": 2,
    "17027": 2,
    "17029": 2,
    "17031": 4,
    "17033": 2,
    "17035": 1,
    "17037": 3,
    "17039": 2,
    "17041": 2,
    "17043": 3,
    "17045": 2,
    "17047": 2,
    "17049": 2,
    "17051": 2,
    "17053": 1,
    "17055": 3,
    "17057": 3,
    "17059": 3,
    "17061": 2,
    "17063": 2,
    "17065": 3,
    "17067": 3,
    "17069": 1,
    "17071": 2,
    "17073": 3,
    "17075": 2,
    "17077": 3,
    "17079": 2,
    "17081": 3,
    "17083": 2,
    "17085": 2,
    "17087": 3,
    "17089": 2,
    "17091": 3,
    "17093": 1,
    "17095": 2,
    "17097": 3,
    "17099": 3,
    "17101": 1,
    "17103": 3,
    "17105": 3,
    "17107": 3,
    "17109": 3,
    "17111": 2,
    "17113": 3,
    "17115": 3,
    "17117": 3,
    "17119": 4,
    "17121": 3,
    "17123": 2,
    "17125": 2,
    "17127": 4,
    "17129": 2,
    "17131": 3,
    "17133": 2,
    "17135": 3,
    "17137": 2,
    "17139": 1,
    "17141": 2,
    "17143": 3,
    "17145": 3,
    "17147": 2,
    "17149": 3,
    "17151": 2,
    "17153": 3,
    "17155": 2,
    "17157": 2,
    "17159": 1,
    "17161": 3,
    "17163": 3,
    "17165": 4,
    "17167": 4,
    "17169": 2,
    "17171": 1,
    "17173": 2,
    "17175": 1,
    "17177": 2,
    "17179": 4,
    "17181": 3,
    "17183": 3,
    "17185": 3,
    "17187": 2,
    "17189": 3,
    "17191": 3,
    "17193": 3,
    "17195": 3,
    "17197": 4,
    "17199": 3,
    "17201": 3,
    "17203": 3,
    "18001": 2,
    "18003": 3,
    "18005": 1,
    "18007": 1,
    "18009": 1,
    "18011": 2,
    "18013": 1,
    "18015": 2,
    "18017": 2,
    "18019": 3,
    "18021": 1,
    "18023": 2,
    "18025": 2,
    "18027": 3,
    "18029": 1,
    "18031": 2,
    "18033": 2,
    "18035": 2,
    "18037": 3,
    "18039": 2,
    "18041": 1,
    "18043": 2,
    "18045": 2,
    "18047": 1,
    "18049": 1,
    "18051": 3,
    "18053": 2,
    "18055": 2,
    "18057": 3,
    "18059": 2,
    "18061": 2,
    "18063": 3,
    "18065": 2,
    "18067": 2,
    "18069": 2,
    "18071": 2,
    "18073": 2,
    "18075": 1,
    "18077": 3,
    "18079": 1,
    "18081": 3,
    "18083": 3,
    "18085": 3,
    "18087": 1,
    "18089": 3,
    "18091": 2,
    "18093": 3,
    "18095": 3,
    "18097": 4,
    "18099": 2,
    "18101": 1,
    "18103": 3,
    "18105": 2,
    "18107": 2,
    "18109": 3,
    "18111": 1,
    "18113": 2,
    "18115": 0,
    "18117": 2,
    "18119": 1,
    "18121": 2,
    "18123": 2,
    "18125": 3,
    "18127": 2,
    "18129": 3,
    "18131": 1,
    "18133": 2,
    "18135": 1,
    "18137": 3,
    "18139": 2,
    "18141": 3,
    "18143": 2,
    "18145": 2,
    "18147": 3,
    "18149": 1,
    "18151": 1,
    "18153": 1,
    "18155": 1,
    "18157": 3,
    "18159": 2,
    "18161": 0,
    "18163": 4,
    "18165": 2,
    "18167": 2,
    "18169": 2,
    "18171": 1,
    "18173": 3,
    "18175": 3,
    "18177": 2,
    "18179": 1,
    "18181": 2,
    "18183": 2,
    "19001": 2,
    "19003": 3,
    "19005": 1,
    "19007": 3,
    "19009": 2,
    "19011": 3,
    "19013": 4,
    "19015": 3,
    "19017": 2,
    "19019": 3,
    "19021": 3,
    "19023": 4,
    "19025": 2,
    "19027": 3,
    "19029": 4,
    "19031": 3,
    "19033": 3,
    "19035": 2,
    "19037": 1,
    "19039": 2,
    "19041": 3,
    "19043": 2,
    "19045": 3,
    "19047": 3,
    "19049": 4,
    "19051": 2,
    "19053": 1,
    "19055": 3,
    "19057": 2,
    "19059": 2,
    "19061": 3,
    "19063": 2,
    "19065": 2,
    "19067": 2,
    "19069": 2,
    "19071": 3,
    "19073": 2,
    "19075": 3,
    "19077": 3,
    "19079": 3,
    "19081": 2,
    "19083": 3,
    "19085": 3,
    "19087": 2,
    "19089": 3,
    "19091": 2,
    "19093": 2,
    "19095": 3,
    "19097": 2,
    "19099": 3,
    "19101": 2,
    "19103": 3,
    "19105": 3,
    "19107": 2,
    "19109": 3,
    "19111": 3,
    "19113": 4,
    "19115": 3,
    "19117": 3,
    "19119": 3,
    "19121": 3,
    "19123": 3,
    "19125": 4,
    "19127": 3,
    "19129": 2,
    "19131": 2,
    "19133": 3,
    "19135": 2,
    "19137": 2,
    "19139": 3,
    "19141": 3,
    "19143": 3,
    "19145": 2,
    "19147": 2,
    "19149": 3,
    "19151": 3,
    "19153": 5,
    "19155": 3,
    "19157": 2,
    "19159": 2,
    "19161": 3,
    "19163": 3,
    "19165": 2,
    "19167": 3,
    "19169": 4,
    "19171": 3,
    "19173": 3,
    "19175": 3,
    "19177": 3,
    "19179": 3,
    "19181": 4,
    "19183": 3,
    "19185": 2,
    "19187": 3,
    "19189": 3,
    "19191": 2,
    "19193": 4,
    "19195": 2,
    "19197": 3,
    "20001": 2,
    "20003": 3,
    "20005": 1,
    "20007": 3,
    "20009": 4,
    "20011": 2,
    "20013": 3,
    "20015": 4,
    "20017": 2,
    "20019": 2,
    "20021": 3,
    "20023": 3,
    "20025": 4,
    "20027": 3,
    "20029": 2,
    "20031": 2,
    "20033": 3,
    "20035": 4,
    "20037": 3,
    "20039": 3,
    "20041": 3,
    "20043": 1,
    "20045": 3,
    "20047": 4,
    "20049": 1,
    "20051": 4,
    "20053": 4,
    "20055": 4,
    "20057": 5,
    "20059": 2,
    "20061": 2,
    "20063": 4,
    "20065": 3,
    "20067": 3,
    "20069": 4,
    "20071": 2,
    "20073": 3,
    "20075": 3,
    "20077": 4,
    "20079": 2,
    "20081": 3,
    "20083": 3,
    "20085": 2,
    "20087": 3,
    "20089": 3,
    "20091": 3,
    "20093": 3,
    "20095": 4,
    "20097": 4,
    "20099": 3,
    "20101": 3,
    "20103": 3,
    "20105": 3,
    "20107": 2,
    "20109": 3,
    "20111": 3,
    "20113": 3,
    "20115": 3,
    "20117": 3,
    "20119": 3,
    "20121": 2,
    "20123": 3,
    "20125": 3,
    "20127": 2,
    "20129": 3,
    "20131": 3,
    "20133": 3,
    "20135": 4,
    "20137": 3,
    "20139": 3,
    "20141": 3,
    "20143": 4,
    "20145": 4,
    "20147": 2,
    "20149": 3,
    "20151": 4,
    "20153": 3,
    "20155": 4,
    "20157": 3,
    "20159": 3,
    "20161": 3,
    "20163": 3,
    "20165": 3,
    "20167": 4,
    "20169": 3,
    "20171": 3,
    "20173": 5,
    "20175": 4,
    "20177": 3,
    "20179": 3,
    "20181": 4,
    "20183": 3,
    "20185": 4,
    "20187": 2,
    "20189": 2,
    "20191": 5,
    "20193": 3,
    "20195": 4,
    "20197": 3,
    "20199": 3,
    "20201": 3,
    "20203": 3,
    "20205": 2,
    "20207": 2,
    "20209": 3,
    "21001": 2,
    "21003": 2,
    "21005": 1,
    "21007": 3,
    "21009": 2,
    "21011": 2,
    "21013": 2,
    "21015": 1,
    "21017": 1,
    "21019": 0,
    "21021": 0,
    "21023": 0,
    "21025": 2,
    "21027": 2,
    "21029": 1,
    "21031": 2,
    "21033": 2,
    "21035": 3,
    "21037": 2,
    "21039": 2,
    "21041": 0,
    "21043": 1,
    "21045": 2,
    "21047": 4,
    "21049": 0,
    "21051": 1,
    "21053": 2,
    "21055": 3,
    "21057": 1,
    "21059": 4,
    "21061": 2,
    "21063": 0,
    "21065": 2,
    "21067": 2,
    "21069": 1,
    "21071": 2,
    "21073": 1,
    "21075": 3,
    "21077": 1,
    "21079": 2,
    "21081": 2,
    "21083": 3,
    "21085": 2,
    "21087": 1,
    "21089": 1,
    "21091": 1,
    "21093": 3,
    "21095": 1,
    "21097": 1,
    "21099": 2,
    "21101": 3,
    "21103": 2,
    "21105": 2,
    "21107": 4,
    "21109": 1,
    "21111": 4,
    "21113": 0,
    "21115": 3,
    "21117": 3,
    "21119": 0,
    "21121": 1,
    "21123": 2,
    "21125": 3,
    "21127": 2,
    "21129": 1,
    "21131": 2,
    "21133": 0,
    "21135": 2,
    "21137": 1,
    "21139": 3,
    "21141": 2,
    "21143": 2,
    "21145": 3,
    "21147": 2,
    "21149": 3,
    "21151": 2,
    "21153": 2,
    "21155": 1,
    "21157": 3,
    "21159": 0,
    "21161": 2,
    "21163": 2,
    "21165": 2,
    "21167": 1,
    "21169": 2,
    "21171": 2,
    "21173": 0,
    "21175": 3,
    "21177": 3,
    "21179": 2,
    "21181": 0,
    "21183": 2,
    "21185": 1,
    "21187": 2,
    "21189": 1,
    "21191": 2,
    "21193": 1,
    "21195": 2,
    "21197": 2,
    "21199": 3,
    "21201": 0,
    "21203": 2,
    "21205": 0,
    "21207": 1,
    "21209": 2,
    "21211": 2,
    "21213": 1,
    "21215": 2,
    "21217": 1,
    "21219": 2,
    "21221": 3,
    "21223": 2,
    "21225": 3,
    "21227": 3,
    "21229": 1,
    "21231": 2,
    "21233": 3,
    "21235": 2,
    "21237": 2,
    "21239": 1,
    "22001": 5,
    "22003": 4,
    "22005": 4,
    "22007": 4,
    "22009": 4,
    "22011": 5,
    "22013": 4,
    "22015": 5,
    "22017": 5,
    "22019": 5,
    "22021": 4,
    "22023": 4,
    "22025": 4,
    "22027": 4,
    "22029": 4,
    "22031": 4,
    "22033": 4,
    "22035": 3,
    "22037": 3,
    "22039": 4,
    "22041": 4,
    "22043": 4,
    "22045": 4,
    "22047": 3,
    "22049": 3,
    "22051": 2,
    "22053": 4,
    "22055": 4,
    "22057": 5,
    "22059": 4,
    "22061": 4,
    "22063": 5,
    "22065": 4,
    "22067": 4,
    "22069": 5,
    "22071": 4,
    "22073": 4,
    "22075": 4,
    "22077": 4,
    "22079": 5,
    "22081": 4,
    "22083": 3,
    "22085": 4,
    "22087": 3,
    "22089": 4,
    "22091": 4,
    "22093": 4,
    "22095": 4,
    "22097": 4,
    "22099": 4,
    "22101": 4,
    "22103": 5,
    "22105": 5,
    "22107": 3,
    "22109": 5,
    "22111": 4,
    "22113": 5,
    "22115": 4,
    "22117": 4,
    "22119": 3,
    "22121": 2,
    "22123": 4,
    "22125": 3,
    "22127": 4,
    "23001": 1,
    "23003": 4,
    "23005": 3,
    "23007": 2,
    "23009": 1,
    "23011": 3,
    "23013": 1,
    "23015": 1,
    "23017": 4,
    "23019": 3,
    "23021": 2,
    "23023": 2,
    "23025": 3,
    "23027": 1,
    "23029": 1,
    "23031": 3,
    "24001": 3,
    "24003": 4,
    "24005": 4,
    "24009": 3,
    "24011": 2,
    "24013": 4,
    "24015": 4,
    "24017": 5,
    "24019": 3,
    "24021": 4,
    "24023": 4,
    "24025": 4,
    "24027": 3,
    "24029": 2,
    "24031": 4,
    "24033": 4,
    "24035": 4,
    "24037": 4,
    "24039": 2,
    "24041": 2,
    "24043": 4,
    "24045": 2,
    "24047": 2,
    "24510": 2,
    "25001": 2,
    "25003": 4,
    "25005": 3,
    "25007": 2,
    "25009": 2,
    "25011": 4,
    "25013": 4,
    "25015": 3,
    "25017": 3,
    "25019": 1,
    "25021": 4,
    "25023": 3,
    "25025": 3,
    "25027": 5,
    "26001": 1,
    "26003": 1,
    "26005": 2,
    "26007": 1,
    "26009": 1,
    "26011": 1,
    "26013": 1,
    "26015": 1,
    "26017": 2,
    "26019": 0,
    "26021": 2,
    "26023": 1,
    "26025": 2,
    "26027": 2,
    "26029": 0,
    "26031": 1,
    "26033": 0,
    "26035": 0,
    "26037": 1,
    "26039": 1,
    "26041": 2,
    "26043": 2,
    "26045": 2,
    "26047": 0,
    "26049": 4,
    "26051": 0,
    "26053": 2,
    "26055": 0,
    "26057": 1,
    "26059": 1,
    "26061": 1,
    "26063": 2,
    "26065": 2,
    "26067": 1,
    "26069": 1,
    "26071": 1,
    "26073": 1,
    "26075": 1,
    "26077": 2,
    "26079": 1,
    "26081": 2,
    "26083": 0,
    "26085": 1,
    "26087": 2,
    "26089": 0,
    "26091": 2,
    "26093": 3,
    "26095": 1,
    "26097": 0,
    "26099": 2,
    "26101": 0,
    "26103": 3,
    "26105": 1,
    "26107": 1,
    "26109": 1,
    "26111": 2,
    "26113": 0,
    "26115": 3,
    "26117": 1,
    "26119": 1,
    "26121": 1,
    "26123": 1,
    "26125": 3,
    "26127": 0,
    "26129": 1,
    "26131": 1,
    "26133": 1,
    "26135": 1,
    "26137": 1,
    "26139": 1,
    "26141": 0,
    "26143": 0,
    "26145": 3,
    "26147": 3,
    "26149": 2,
    "26151": 2,
    "26153": 1,
    "26155": 2,
    "26157": 2,
    "26159": 2,
    "26161": 3,
    "26163": 3,
    "26165": 0,
    "27001": 2,
    "27003": 3,
    "27005": 3,
    "27007": 3,
    "27009": 1,
    "27011": 2,
    "27013": 4,
    "27015": 3,
    "27017": 1,
    "27019": 2,
    "27021": 2,
    "27023": 2,
    "27025": 2,
    "27027": 3,
    "27029": 3,
    "27031": 1,
    "27033": 3,
    "27035": 3,
    "27037": 3,
    "27039": 2,
    "27041": 2,
    "27043": 2,
    "27045": 2,
    "27047": 3,
    "27049": 3,
    "27051": 2,
    "27053": 3,
    "27055": 2,
    "27057": 3,
    "27059": 2,
    "27061": 2,
    "27063": 2,
    "27065": 2,
    "27067": 3,
    "27069": 3,
    "27071": 0,
    "27073": 2,
    "27075": 1,
    "27077": 2,
    "27079": 3,
    "27081": 2,
    "27083": 2,
    "27085": 2,
    "27087": 2,
    "27089": 3,
    "27091": 2,
    "27093": 2,
    "27095": 1,
    "27097": 3,
    "27099": 2,
    "27101": 2,
    "27103": 3,
    "27105": 3,
    "27107": 3,
    "27109": 3,
    "27111": 5,
    "27113": 1,
    "27115": 2,
    "27117": 2,
    "27119": 4,
    "27121": 2,
    "27123": 2,
    "27125": 3,
    "27127": 2,
    "27129": 2,
    "27131": 3,
    "27133": 2,
    "27135": 3,
    "27137": 3,
    "27139": 2,
    "27141": 2,
    "27143": 2,
    "27145": 3,
    "27147": 2,
    "27149": 2,
    "27151": 3,
    "27153": 2,
    "27155": 2,
    "27157": 2,
    "27159": 3,
    "27161": 2,
    "27163": 3,
    "27165": 3,
    "27167": 3,
    "27169": 2,
    "27171": 3,
    "27173": 3,
    "28001": 4,
    "28003": 2,
    "28005": 3,
    "28007": 4,
    "28009": 3,
    "28011": 3,
    "28013": 3,
    "28015": 3,
    "28017": 3,
    "28019": 3,
    "28021": 4,
    "28023": 3,
    "28025": 3,
    "28027": 3,
    "28029": 4,
    "28031": 5,
    "28033": 3,
    "28035": 5,
    "28037": 3,
    "28039": 3,
    "28041": 4,
    "28043": 2,
    "28045": 4,
    "28047": 5,
    "28049": 5,
    "28051": 4,
    "28053": 2,
    "28055": 2,
    "28057": 3,
    "28059": 4,
    "28061": 5,
    "28063": 2,
    "28065": 4,
    "28067": 5,
    "28069": 4,
    "28071": 3,
    "28073": 5,
    "28075": 4,
    "28077": 4,
    "28079": 4,
    "28081": 4,
    "28083": 3,
    "28085": 4,
    "28087": 4,
    "28089": 4,
    "28091": 4,
    "28093": 3,
    "28095": 5,
    "28097": 3,
    "28099": 5,
    "28101": 4,
    "28103": 4,
    "28105": 3,
    "28107": 2,
    "28109": 5,
    "28111": 4,
    "28113": 4,
    "28115": 3,
    "28117": 2,
    "28119": 2,
    "28121": 5,
    "28123": 4,
    "28125": 3,
    "28127": 4,
    "28129": 4,
    "28131": 4,
    "28133": 3,
    "28135": 2,
    "28137": 3,
    "28139": 3,
    "28141": 2,
    "28143": 1,
    "28145": 2,
    "28147": 4,
    "28149": 4,
    "28151": 4,
    "28153": 4,
    "28155": 3,
    "28157": 3,
    "28159": 3,
    "28161": 2,
    "28163": 4,
    "29001": 2,
    "29003": 2,
    "29005": 2,
    "29007": 2,
    "29009": 4,
    "29011": 3,
    "29013": 2,
    "29015": 2,
    "29017": 3,
    "29019": 3,
    "29021": 2,
    "29023": 4,
    "29025": 0,
    "29027": 3,
    "29029": 3,
    "29031": 4,
    "29033": 2,
    "29035": 3,
    "29037": 3,
    "29039": 3,
    "29041": 1,
    "29043": 3,
    "29045": 2,
    "29047": 4,
    "29049": 2,
    "29051": 2,
    "29053": 2,
    "29055": 2,
    "29057": 2,
    "29059": 2,
    "29061": 2,
    "29063": 3,
    "29065": 2,
    "29067": 3,
    "29069": 3,
    "29071": 3,
    "29073": 2,
    "29075": 2,
    "29077": 5,
    "29079": 2,
    "29081": 3,
    "29083": 2,
    "29085": 2,
    "29087": 1,
    "29089": 1,
    "29091": 4,
    "29093": 2,
    "29095": 4,
    "29097": 3,
    "29099": 3,
    "29101": 3,
    "29103": 1,
    "29105": 3,
    "29107": 2,
    "29109": 4,
    "29111": 2,
    "29113": 2,
    "29115": 2,
    "29117": 1,
    "29119": 3,
    "29121": 2,
    "29123": 2,
    "29125": 1,
    "29127": 2,
    "29129": 1,
    "29131": 2,
    "29133": 2,
    "29135": 1,
    "29137": 3,
    "29139": 3,
    "29141": 2,
    "29143": 3,
    "29145": 4,
    "29147": 2,
    "29149": 2,
    "29151": 2,
    "29153": 3,
    "29155": 2,
    "29157": 4,
    "29159": 3,
    "29161": 3,
    "29163": 2,
    "29165": 4,
    "29167": 4,
    "29169": 3,
    "29171": 1,
    "29173": 2,
    "29175": 2,
    "29177": 2,
    "29179": 2,
    "29181": 3,
    "29183": 4,
    "29185": 3,
    "29186": 2,
    "29187": 2,
    "29189": 5,
    "29195": 3,
    "29197": 1,
    "29199": 2,
    "29201": 3,
    "29203": 2,
    "29205": 2,
    "29207": 3,
    "29209": 3,
    "29211": 1,
    "29213": 3,
    "29215": 2,
    "29217": 3,
    "29219": 2,
    "29221": 2,
    "29223": 3,
    "29225": 4,
    "29227": 1,
    "29229": 3,
    "29510": 2,
    "30001": 2,
    "30003": 2,
    "30005": 2,
    "30007": 0,
    "30009": 2,
    "30011": 3,
    "30013": 2,
    "30015": 2,
    "30017": 2,
    "30019": 2,
    "30021": 2,
    "30023": 1,
    "30025": 3,
    "30027": 3,
    "30029": 2,
    "30031": 1,
    "30033": 2,
    "30035": 3,
    "30037": 0,
    "30039": 1,
    "30041": 1,
    "30043": 0,
    "30045": 2,
    "30047": 2,
    "30049": 3,
    "30051": 1,
    "30053": 1,
    "30055": 2,
    "30057": 1,
    "30059": 1,
    "30061": 1,
    "30063": 2,
    "30065": 1,
    "30067": 3,
    "30069": 1,
    "30071": 3,
    "30073": 2,
    "30075": 3,
    "30077": 1,
    "30079": 1,
    "30081": 1,
    "30083": 2,
    "30085": 3,
    "30087": 2,
    "30089": 1,
    "30091": 2,
    "30093": 1,
    "30095": 2,
    "30097": 1,
    "30099": 1,
    "30101": 0,
    "30103": 0,
    "30105": 4,
    "30107": 2,
    "30109": 1,
    "30111": 3,
    "31001": 3,
    "31003": 3,
    "31005": 2,
    "31007": 2,
    "31009": 2,
    "31011": 2,
    "31013": 2,
    "31015": 0,
    "31017": 2,
    "31019": 3,
    "31021": 2,
    "31023": 2,
    "31025": 3,
    "31027": 3,
    "31029": 2,
    "31031": 5,
    "31033": 3,
    "31035": 3,
    "31037": 2,
    "31039": 3,
    "31041": 4,
    "31043": 2,
    "31045": 2,
    "31047": 3,
    "31049": 2,
    "31051": 2,
    "31053": 3,
    "31055": 3,
    "31057": 2,
    "31059": 3,
    "31061": 2,
    "31063": 3,
    "31065": 2,
    "31067": 4,
    "31069": 2,
    "31071": 2,
    "31073": 2,
    "31075": 1,
    "31077": 2,
    "31079": 2,
    "31081": 3,
    "31083": 2,
    "31085": 2,
    "31087": 2,
    "31089": 4,
    "31091": 2,
    "31093": 2,
    "31095": 3,
    "31097": 2,
    "31099": 2,
    "31101": 3,
    "31103": 2,
    "31105": 3,
    "31107": 3,
    "31109": 4,
    "31111": 5,
    "31113": 1,
    "31115": 2,
    "31117": 2,
    "31119": 2,
    "31121": 2,
    "31123": 3,
    "31125": 2,
    "31127": 2,
    "31129": 3,
    "31131": 2,
    "31133": 1,
    "31135": 3,
    "31137": 3,
    "31139": 2,
    "31141": 3,
    "31143": 2,
    "31145": 3,
    "31147": 2,
    "31149": 2,
    "31151": 3,
    "31153": 3,
    "31155": 3,
    "31157": 3,
    "31159": 3,
    "31161": 3,
    "31163": 2,
    "31165": 2,
    "31167": 3,
    "31169": 3,
    "31171": 2,
    "31173": 2,
    "31175": 3,
    "31177": 2,
    "31179": 3,
    "31181": 2,
    "31183": 2,
    "31185": 3,
    "32001": 0,
    "32003": 3,
    "32005": 2,
    "32007": 3,
    "32009": 0,
    "32011": 0,
    "32013": 0,
    "32015": 0,
    "32017": 2,
    "32019": 3,
    "32021": 2,
    "32023": 3,
    "32027": 0,
    "32029": 2,
    "32031": 4,
    "32033": 0,
    "32510": 2,
    "33001": 3,
    "33003": 3,
    "33005": 2,
    "33007": 3,
    "33009": 3,
    "33011": 3,
    "33013": 3,
    "33015": 4,
    "33017": 3,
    "33019": 2,
    "34001": 3,
    "34003": 3,
    "34005": 3,
    "34007": 3,
    "34009": 3,
    "34011": 2,
    "34013": 2,
    "34015": 3,
    "34017": 2,
    "34019": 3,
    "34021": 3,
    "34023": 4,
    "34025": 3,
    "34027": 3,
    "34029": 4,
    "34031": 3,
    "34033": 2,
    "34035": 3,
    "34037": 3,
    "34039": 2,
    "34041": 2,
    "35001": 2,
    "35003": 1,
    "35005": 3,
    "35006": 1,
    "35007": 4,
    "35009": 2,
    "35011": 1,
    "35013": 2,
    "35015": 3,
    "35017": 1,
    "35019": 1,
    "35021": 1,
    "35023": 1,
    "35025": 3,
    "35027": 3,
    "35028": 0,
    "35029": 1,
    "35031": 1,
    "35033": 2,
    "35035": 2,
    "35037": 2,
    "35039": 2,
    "35041": 3,
    "35043": 3,
    "35045": 2,
    "35047": 3,
    "35049": 3,
    "35051": 0,
    "35053": 2,
    "35055": 2,
    "35057": 3,
    "35059": 3,
    "35061": 2,
    "36001": 3,
    "36003": 3,
    "36005": 2,
    "36007": 4,
    "36009": 3,
    "36011": 2,
    "36013": 3,
    "36015": 2,
    "36017": 3,
    "36019": 3,
    "36021": 4,
    "36023": 2,
    "36025": 3,
    "36027": 4,
    "36029": 3,
    "36031": 2,
    "36033": 2,
    "36035": 3,
    "36037": 1,
    "36039": 4,
    "36041": 1,
    "36043": 3,
    "36045": 1,
    "36047": 2,
    "36049": 2,
    "36051": 1,
    "36053": 3,
    "36055": 1,
    "36057": 3,
    "36059": 3,
    "36061": 1,
    "36063": 1,
    "36065": 4,
    "36067": 2,
    "36069": 2,
    "36071": 3,
    "36073": 1,
    "36075": 2,
    "36077": 3,
    "36079": 3,
    "36081": 2,
    "36083": 4,
    "36085": 2,
    "36087": 3,
    "36089": 2,
    "36091": 4,
    "36093": 4,
    "36095": 2,
    "36097": 1,
    "36099": 0,
    "36101": 3,
    "36103": 4,
    "36105": 3,
    "36107": 2,
    "36109": 2,
    "36111": 4,
    "36113": 2,
    "36115": 3,
    "36117": 3,
    "36119": 4,
    "36121": 2,
    "36123": 1,
    "37001": 3,
    "37003": 2,
    "37005": 3,
    "37007": 3,
    "37009": 2,
    "37011": 2,
    "37013": 5,
    "37015": 4,
    "37017": 5,
    "37019": 4,
    "37021": 3,
    "37023": 3,
    "37025": 2,
    "37027": 4,
    "37029": 3,
    "37031": 5,
    "37033": 3,
    "37035": 3,
    "37037": 3,
    "37039": 1,
    "37041": 4,
    "37043": 0,
    "37045": 3,
    "37047": 5,
    "37049": 5,
    "37051": 4,
    "37053": 3,
    "37055": 4,
    "37057": 4,
    "37059": 3,
    "37061": 5,
    "37063": 3,
    "37065": 3,
    "37067": 4,
    "37069": 3,
    "37071": 3,
    "37073": 2,
    "37075": 1,
    "37077": 3,
    "37079": 4,
    "37081": 4,
    "37083": 4,
    "37085": 3,
    "37087": 1,
    "37089": 2,
    "37091": 4,
    "37093": 2,
    "37095": 4,
    "37097": 3,
    "37099": 2,
    "37101": 4,
    "37103": 4,
    "37105": 3,
    "37107": 4,
    "37109": 3,
    "37111": 3,
    "37113": 2,
    "37115": 2,
    "37117": 4,
    "37119": 4,
    "37121": 1,
    "37123": 2,
    "37125": 3,
    "37127": 3,
    "37129": 5,
    "37131": 3,
    "37133": 5,
    "37135": 3,
    "37137": 4,
    "37139": 4,
    "37141": 4,
    "37143": 4,
    "37145": 4,
    "37147": 4,
    "37149": 2,
    "37151": 3,
    "37153": 3,
    "37155": 4,
    "37157": 4,
    "37159": 3,
    "37161": 3,
    "37163": 4,
    "37165": 2,
    "37167": 3,
    "37169": 3,
    "37171": 3,
    "37173": 1,
    "37175": 1,
    "37177": 4,
    "37179": 3,
    "37181": 3,
    "37183": 4,
    "37185": 2,
    "37187": 3,
    "37189": 2,
    "37191": 4,
    "37193": 3,
    "37195": 4,
    "37197": 3,
    "37199": 2,
    "38001": 1,
    "38003": 3,
    "38005": 3,
    "38007": 0,
    "38009": 1,
    "38011": 1,
    "38013": 2,
    "38015": 3,
    "38017": 4,
    "38019": 3,
    "38021": 2,
    "38023": 1,
    "38025": 2,
    "38027": 2,
    "38029": 1,
    "38031": 1,
    "38033": 1,
    "38035": 4,
    "38037": 2,
    "38039": 2,
    "38041": 2,
    "38043": 2,
    "38045": 2,
    "38047": 1,
    "38049": 2,
    "38051": 1,
    "38053": 2,
    "38055": 3,
    "38057": 1,
    "38059": 3,
    "38061": 1,
    "38063": 3,
    "38065": 1,
    "38067": 3,
    "38069": 1,
    "38071": 2,
    "38073": 3,
    "38075": 1,
    "38077": 4,
    "38079": 2,
    "38081": 3,
    "38083": 1,
    "38085": 1,
    "38087": 0,
    "38089": 2,
    "38091": 2,
    "38093": 3,
    "38095": 3,
    "38097": 3,
    "38099": 4,
    "38101": 2,
    "38103": 1,
    "38105": 1,
    "39001": 2,
    "39003": 2,
    "39005": 2,
    "39007": 3,
    "39009": 2,
    "39011": 2,
    "39013": 1,
    "39015": 2,
    "39017": 2,
    "39019": 2,
    "39021": 1,
    "39023": 2,
    "39025": 3,
    "39027": 2,
    "39029": 2,
    "39031": 1,
    "39033": 2,
    "39035": 3,
    "39037": 2,
    "39039": 2,
    "39041": 2,
    "39043": 2,
    "39045": 3,
    "39047": 2,
    "39049": 3,
    "39051": 1,
    "39053": 2,
    "39055": 2,
    "39057": 3,
    "39059": 1,
    "39061": 4,
    "39063": 2,
    "39065": 1,
    "39067": 1,
    "39069": 2,
    "39071": 2,
    "39073": 1,
    "39075": 2,
    "39077": 2,
    "39079": 1,
    "39081": 0,
    "39083": 1,
    "39085": 1,
    "39087": 2,
    "39089": 3,
    "39091": 3,
    "39093": 3,
    "39095": 3,
    "39097": 1,
    "39099": 2,
    "39101": 2,
    "39103": 3,
    "39105": 2,
    "39107": 2,
    "39109": 2,
    "39111": 0,
    "39113": 3,
    "39115": 0,
    "39117": 1,
    "39119": 1,
    "39121": 1,
    "39123": 2,
    "39125": 2,
    "39127": 2,
    "39129": 2,
    "39131": 2,
    "39133": 2,
    "39135": 2,
    "39137": 3,
    "39139": 2,
    "39141": 2,
    "39143": 2,
    "39145": 2,
    "39147": 3,
    "39149": 1,
    "39151": 3,
    "39153": 3,
    "39155": 2,
    "39157": 2,
    "39159": 1,
    "39161": 3,
    "39163": 1,
    "39165": 3,
    "39167": 2,
    "39169": 3,
    "39171": 0,
    "39173": 3,
    "39175": 0,
    "40001": 3,
    "40003": 3,
    "40005": 3,
    "40007": 4,
    "40009": 4,
    "40011": 3,
    "40013": 3,
    "40015": 4,
    "40017": 5,
    "40019": 3,
    "40021": 4,
    "40023": 3,
    "40025": 3,
    "40027": 5,
    "40029": 2,
    "40031": 3,
    "40033": 2,
    "40035": 3,
    "40037": 4,
    "40039": 3,
    "40041": 4,
    "40043": 3,
    "40045": 3,
    "40047": 4,
    "40049": 3,
    "40051": 5,
    "40053": 4,
    "40055": 2,
    "40057": 2,
    "40059": 3,
    "40061": 3,
    "40063": 2,
    "40065": 4,
    "40067": 3,
    "40069": 3,
    "40071": 4,
    "40073": 4,
    "40075": 3,
    "40077": 3,
    "40079": 4,
    "40081": 4,
    "40083": 4,
    "40085": 3,
    "40087": 4,
    "40089": 4,
    "40091": 4,
    "40093": 3,
    "40095": 2,
    "40097": 3,
    "40099": 3,
    "40101": 4,
    "40103": 2,
    "40105": 3,
    "40107": 3,
    "40109": 5,
    "40111": 3,
    "40113": 4,
    "40115": 4,
    "40117": 4,
    "40119": 4,
    "40121": 3,
    "40123": 3,
    "40125": 3,
    "40127": 3,
    "40129": 3,
    "40131": 4,
    "40133": 3,
    "40135": 3,
    "40137": 3,
    "40139": 4,
    "40141": 3,
    "40143": 5,
    "40145": 3,
    "40147": 3,
    "40149": 3,
    "40151": 4,
    "40153": 3,
    "41001": 0,
    "41003": 0,
    "41005": 2,
    "41007": 2,
    "41009": 1,
    "41011": 2,
    "41013": 0,
    "41015": 2,
    "41017": 1,
    "41019": 2,
    "41021": 0,
    "41023": 0,
    "41025": 0,
    "41027": 1,
    "41029": 1,
    "41031": 0,
    "41033": 0,
    "41035": 1,
    "41037": 1,
    "41039": 2,
    "41041": 2,
    "41043": 2,
    "41045": 0,
    "41047": 2,
    "41049": 1,
    "41051": 1,
    "41053": 1,
    "41055": 0,
    "41057": 3,
    "41059": 2,
    "41061": 1,
    "41063": 1,
    "41065": 0,
    "41067": 1,
    "41069": 0,
    "41071": 1,
    "42001": 3,
    "42003": 4,
    "42005": 2,
    "42007": 3,
    "42009": 2,
    "42011": 4,
    "42013": 2,
    "42015": 3,
    "42017": 3,
    "42019": 3,
    "42021": 3,
    "42023": 2,
    "42025": 3,
    "42027": 3,
    "42029": 4,
    "42031": 3,
    "42033": 2,
    "42035": 3,
    "42037": 2,
    "42039": 4,
    "42041": 3,
    "42043": 3,
    "42045": 3,
    "42047": 2,
    "42049": 3,
    "42051": 3,
    "42053": 1,
    "42055": 3,
    "42057": 2,
    "42059": 2,
    "42061": 2,
    "42063": 3,
    "42065": 3,
    "42067": 3,
    "42069": 3,
    "42071": 4,
    "42073": 2,
    "42075": 3,
    "42077": 3,
    "42079": 4,
    "42081": 4,
    "42083": 2,
    "42085": 3,
    "42087": 1,
    "42089": 4,
    "42091": 3,
    "42093": 1,
    "42095": 4,
    "42097": 2,
    "42099": 2,
    "42101": 4,
    "42103": 4,
    "42105": 3,
    "42107": 2,
    "42109": 1,
    "42111": 4,
    "42113": 3,
    "42115": 3,
    "42117": 2,
    "42119": 2,
    "42121": 2,
    "42123": 3,
    "42125": 3,
    "42127": 3,
    "42129": 4,
    "42131": 3,
    "42133": 4,
    "44001": 2,
    "44003": 2,
    "44005": 2,
    "44007": 3,
    "44009": 2,
    "45001": 3,
    "45003": 4,
    "45005": 4,
    "45007": 4,
    "45009": 4,
    "45011": 4,
    "45013": 4,
    "45015": 5,
    "45017": 4,
    "45019": 5,
    "45021": 3,
    "45023": 2,
    "45025": 3,
    "45027": 4,
    "45029": 4,
    "45031": 4,
    "45033": 4,
    "45035": 4,
    "45037": 3,
    "45039": 3,
    "45041": 4,
    "45043": 4,
    "45045": 4,
    "45047": 2,
    "45049": 3,
    "45051": 4,
    "45053": 3,
    "45055": 4,
    "45057": 3,
    "45059": 3,
    "45061": 3,
    "45063": 4,
    "45065": 3,
    "45067": 3,
    "45069": 3,
    "45071": 4,
    "45073": 4,
    "45075": 5,
    "45077": 4,
    "45079": 4,
    "45081": 3,
    "45083": 4,
    "45085": 4,
    "45087": 3,
    "45089": 3,
    "45091": 4,
    "46003": 2,
    "46005": 3,
    "46007": 1,
    "46009": 2,
    "46011": 2,
    "46013": 4,
    "46015": 2,
    "46017": 0,
    "46019": 2,
    "46021": 1,
    "46023": 2,
    "46025": 2,
    "46027": 2,
    "46029": 2,
    "46031": 2,
    "46033": 3,
    "46035": 2,
    "46037": 2,
    "46039": 2,
    "46041": 2,
    "46043": 1,
    "46045": 3,
    "46047": 2,
    "46049": 2,
    "46051": 2,
    "46053": 2,
    "46055": 2,
    "46057": 2,
    "46059": 3,
    "46061": 3,
    "46063": 3,
    "46065": 1,
    "46067": 2,
    "46069": 1,
    "46071": 2,
    "46073": 3,
    "46075": 1,
    "46077": 3,
    "46079": 2,
    "46081": 3,
    "46083": 3,
    "46085": 2,
    "46087": 2,
    "46089": 3,
    "46091": 2,
    "46093": 4,
    "46095": 1,
    "46097": 2,
    "46099": 3,
    "46101": 1,
    "46103": 4,
    "46105": 3,
    "46107": 1,
    "46109": 2,
    "46111": 2,
    "46113": 0,
    "46115": 2,
    "46117": 2,
    "46119": 1,
    "46121": 2,
    "46123": 3,
    "46125": 3,
    "46127": 2,
    "46129": 2,
    "46135": 2,
    "46137": 3,
    "47001": 2,
    "47003": 3,
    "47005": 3,
    "47007": 0,
    "47009": 2,
    "47011": 3,
    "47013": 2,
    "47015": 2,
    "47017": 3,
    "47019": 1,
    "47021": 2,
    "47023": 1,
    "47025": 2,
    "47027": 0,
    "47029": 2,
    "47031": 3,
    "47033": 2,
    "47035": 3,
    "47037": 4,
    "47039": 1,
    "47041": 2,
    "47043": 3,
    "47045": 3,
    "47047": 2,
    "47049": 2,
    "47051": 3,
    "47053": 3,
    "47055": 3,
    "47057": 1,
    "47059": 3,
    "47061": 2,
    "47063": 1,
    "47065": 4,
    "47067": 0,
    "47069": 3,
    "47071": 3,
    "47073": 1,
    "47075": 2,
    "47077": 2,
    "47079": 3,
    "47081": 3,
    "47083": 2,
    "47085": 2,
    "47087": 2,
    "47089": 1,
    "47091": 1,
    "47093": 2,
    "47095": 1,
    "47097": 2,
    "47099": 4,
    "47101": 2,
    "47103": 3,
    "47105": 2,
    "47107": 2,
    "47109": 2,
    "47111": 2,
    "47113": 4,
    "47115": 2,
    "47117": 2,
    "47119": 2,
    "47121": 0,
    "47123": 4,
    "47125": 3,
    "47127": 2,
    "47129": 2,
    "47131": 2,
    "47133": 2,
    "47135": 3,
    "47137": 2,
    "47139": 2,
    "47141": 3,
    "47143": 3,
    "47145": 1,
    "47147": 3,
    "47149": 4,
    "47151": 2,
    "47153": 3,
    "47155": 2,
    "47157": 3,
    "47159": 2,
    "47161": 2,
    "47163": 2,
    "47165": 4,
    "47167": 2,
    "47169": 2,
    "47171": 0,
    "47173": 0,
    "47175": 1,
    "47177": 2,
    "47179": 2,
    "47181": 3,
    "47183": 2,
    "47185": 2,
    "47187": 4,
    "47189": 4,
    "48001": 3,
    "48003": 2,
    "48005": 4,
    "48007": 4,
    "48009": 3,
    "48011": 3,
    "48013": 2,
    "48015": 2,
    "48017": 2,
    "48019": 1,
    "48021": 3,
    "48023": 2,
    "48025": 4,
    "48027": 4,
    "48029": 5,
    "48031": 2,
    "48033": 2,
    "48035": 3,
    "48037": 4,
    "48039": 4,
    "48041": 3,
    "48043": 2,
    "48045": 3,
    "48047": 2,
    "48049": 3,
    "48051": 3,
    "48053": 3,
    "48055": 2,
    "48057": 4,
    "48059": 3,
    "48061": 4,
    "48063": 1,
    "48065": 4,
    "48067": 4,
    "48069": 3,
    "48071": 3,
    "48073": 4,
    "48075": 3,
    "48077": 3,
    "48079": 2,
    "48081": 2,
    "48083": 3,
    "48085": 4,
    "48087": 3,
    "48089": 3,
    "48091": 3,
    "48093": 2,
    "48095": 2,
    "48097": 3,
    "48099": 3,
    "48101": 3,
    "48103": 1,
    "48105": 2,
    "48107": 3,
    "48109": 2,
    "48111": 3,
    "48113": 5,
    "48115": 2,
    "48117": 3,
    "48119": 1,
    "48121": 4,
    "48123": 3,
    "48125": 3,
    "48127": 1,
    "48129": 4,
    "48131": 3,
    "48133": 3,
    "48135": 3,
    "48137": 2,
    "48139": 4,
    "48141": 1,
    "48143": 3,
    "48145": 2,
    "48147": 3,
    "48149": 2,
    "48151": 3,
    "48153": 4,
    "48155": 2,
    "48157": 4,
    "48159": 3,
    "48161": 2,
    "48163": 2,
    "48165": 3,
    "48167": 4,
    "48169": 2,
    "48171": 3,
    "48173": 3,
    "48175": 3,
    "48177": 2,
    "48179": 4,
    "48181": 4,
    "48183": 4,
    "48185": 3,
    "48187": 3,
    "48189": 3,
    "48191": 3,
    "48193": 2,
    "48195": 3,
    "48197": 3,
    "48199": 3,
    "48201": 4,
    "48203": 5,
    "48205": 3,
    "48207": 3,
    "48209": 3,
    "48211": 3,
    "48213": 4,
    "48215": 4,
    "48217": 4,
    "48219": 3,
    "48221": 4,
    "48223": 3,
    "48225": 3,
    "48227": 3,
    "48229": 2,
    "48231": 3,
    "48233": 3,
    "48235": 2,
    "48237": 2,
    "48239": 3,
    "48241": 4,
    "48243": 2,
    "48245": 4,
    "48247": 3,
    "48249": 4,
    "48251": 3,
    "48253": 3,
    "48255": 3,
    "48257": 3,
    "48259": 2,
    "48261": 3,
    "48263": 3,
    "48265": 1,
    "48267": 2,
    "48269": 2,
    "48271": 2,
    "48273": 4,
    "48275": 3,
    "48277": 3,
    "48279": 3,
    "48281": 2,
    "48283": 2,
    "48285": 3,
    "48287": 2,
    "48289": 2,
    "48291": 4,
    "48293": 3,
    "48295": 3,
    "48297": 3,
    "48299": 2,
    "48301": 2,
    "48303": 4,
    "48305": 3,
    "48307": 3,
    "48309": 4,
    "48311": 2,
    "48313": 2,
    "48315": 3,
    "48317": 2,
    "48319": 3,
    "48321": 3,
    "48323": 3,
    "48325": 3,
    "48327": 1,
    "48329": 3,
    "48331": 3,
    "48333": 2,
    "48335": 3,
    "48337": 3,
    "48339": 4,
    "48341": 4,
    "48343": 3,
    "48345": 3,
    "48347": 4,
    "48349": 4,
    "48351": 4,
    "48353": 3,
    "48355": 5,
    "48357": 3,
    "48359": 2,
    "48361": 3,
    "48363": 3,
    "48365": 3,
    "48367": 3,
    "48369": 3,
    "48371": 3,
    "48373": 3,
    "48375": 3,
    "48377": 0,
    "48379": 2,
    "48381": 4,
    "48383": 2,
    "48385": 1,
    "48387": 3,
    "48389": 3,
    "48391": 3,
    "48393": 2,
    "48395": 2,
    "48397": 3,
    "48399": 3,
    "48401": 3,
    "48403": 3,
    "48405": 3,
    "48407": 3,
    "48409": 4,
    "48411": 2,
    "48413": 2,
    "48415": 2,
    "48417": 3,
    "48419": 4,
    "48421": 2,
    "48423": 4,
    "48425": 2,
    "48427": 3,
    "48429": 2,
    "48431": 2,
    "48433": 2,
    "48435": 2,
    "48437": 3,
    "48439": 5,
    "48441": 3,
    "48443": 2,
    "48445": 3,
    "48447": 3,
    "48449": 3,
    "48451": 4,
    "48453": 5,
    "48455": 3,
    "48457": 3,
    "48459": 3,
    "48461": 2,
    "48463": 3,
    "48465": 3,
    "48467": 4,
    "48469": 3,
    "48471": 3,
    "48473": 3,
    "48475": 1,
    "48477": 2,
    "48479": 3,
    "48481": 3,
    "48483": 4,
    "48485": 3,
    "48487": 3,
    "48489": 4,
    "48491": 5,
    "48493": 3,
    "48495": 1,
    "48497": 4,
    "48499": 3,
    "48501": 2,
    "48503": 3,
    "48505": 2,
    "48507": 2,
    "49001": 0,
    "49003": 2,
    "49005": 1,
    "49007": 0,
    "49009": 1,
    "49011": 2,
    "49013": 0,
    "49015": 1,
    "49017": 1,
    "49019": 2,
    "49021": 0,
    "49023": 2,
    "49025": 0,
    "49027": 0,
    "49029": 2,
    "49031": 0,
    "49033": 1,
    "49035": 4,
    "49037": 2,
    "49039": 2,
    "49041": 0,
    "49043": 2,
    "49045": 1,
    "49047": 3,
    "49049": 3,
    "49051": 2,
    "49053": 1,
    "49055": 0,
    "49057": 3,
    "50001": 2,
    "50003": 2,
    "50005": 2,
    "50007": 2,
    "50009": 1,
    "50011": 2,
    "50013": 1,
    "50015": 2,
    "50017": 2,
    "50019": 2,
    "50021": 2,
    "50023": 1,
    "50025": 3,
    "50027": 1,
    "51001": 3,
    "51003": 3,
    "51005": 1,
    "51007": 3,
    "51009": 2,
    "51011": 3,
    "51013": 2,
    "51015": 3,
    "51017": 1,
    "51019": 4,
    "51021": 0,
    "51023": 2,
    "51025": 3,
    "51027": 0,
    "51029": 2,
    "51031": 4,
    "51033": 3,
    "51035": 1,
    "51036": 2,
    "51037": 0,
    "51041": 4,
    "51043": 3,
    "51045": 2,
    "51047": 4,
    "51049": 2,
    "51051": 1,
    "51053": 3,
    "51057": 3,
    "51059": 4,
    "51061": 4,
    "51063": 2,
    "51065": 2,
    "51067": 3,
    "51069": 2,
    "51071": 1,
    "51073": 2,
    "51075": 2,
    "51077": 2,
    "51079": 2,
    "51081": 2,
    "51083": 4,
    "51085": 4,
    "51087": 3,
    "51089": 3,
    "51091": 1,
    "51093": 3,
    "51095": 4,
    "51097": 4,
    "51099": 3,
    "51101": 3,
    "51103": 3,
    "51105": 2,
    "51107": 4,
    "51109": 3,
    "51111": 3,
    "51113": 3,
    "51115": 2,
    "51117": 3,
    "51119": 4,
    "51121": 2,
    "51125": 2,
    "51127": 3,
    "51131": 2,
    "51133": 3,
    "51135": 3,
    "51137": 3,
    "51139": 2,
    "51141": 3,
    "51143": 4,
    "51145": 2,
    "51147": 2,
    "51149": 2,
    "51153": 4,
    "51155": 3,
    "51157": 2,
    "51159": 3,
    "51161": 1,
    "51163": 2,
    "51165": 3,
    "51167": 2,
    "51169": 1,
    "51171": 3,
    "51173": 2,
    "51175": 3,
    "51177": 3,
    "51179": 3,
    "51181": 3,
    "51183": 3,
    "51185": 1,
    "51187": 3,
    "51191": 3,
    "51193": 3,
    "51195": 2,
    "51197": 1,
    "51199": 3,
    "51510": 2,
    "51515": 0,
    "51520": 1,
    "51530": 1,
    "51540": 1,
    "51550": 3,
    "51570": 2,
    "51580": 0,
    "51590": 2,
    "51595": 1,
    "51600": 0,
    "51610": 1,
    "51620": 0,
    "51630": 2,
    "51640": 1,
    "51650": 3,
    "51660": 1,
    "51670": 2,
    "51678": 1,
    "51680": 3,
    "51683": 2,
    "51685": 1,
    "51690": 1,
    "51700": 2,
    "51710": 3,
    "51720": 1,
    "51730": 2,
    "51735": 2,
    "51740": 3,
    "51750": 0,
    "51760": 0,
    "51770": 0,
    "51775": 0,
    "51790": 1,
    "51800": 4,
    "51810": 3,
    "51820": 1,
    "51830": 2,
    "51840": 1,
    "53001": 0,
    "53003": 0,
    "53005": 0,
    "53007": 1,
    "53009": 0,
    "53011": 1,
    "53013": 0,
    "53015": 1,
    "53017": 1,
    "53019": 0,
    "53021": 0,
    "53023": 0,
    "53025": 1,
    "53027": 1,
    "53029": 0,
    "53031": 0,
    "53033": 0,
    "53035": 0,
    "53037": 0,
    "53039": 0,
    "53041": 0,
    "53043": 2,
    "53045": 0,
    "53047": 2,
    "53049": 0,
    "53051": 1,
    "53053": 0,
    "53055": 0,
    "53057": 0,
    "53059": 0,
    "53061": 0,
    "53063": 2,
    "53065": 2,
    "53067": 0,
    "53069": 0,
    "53071": 0,
    "53073": 0,
    "53075": 0,
    "53077": 1,
    "54001": 2,
    "54003": 3,
    "54005": 1,
    "54007": 1,
    "54009": 0,
    "54011": 2,
    "54013": 0,
    "54015": 1,
    "54017": 0,
    "54019": 1,
    "54021": 1,
    "54023": 2,
    "54025": 1,
    "54027": 1,
    "54029": 0,
    "54031": 1,
    "54033": 2,
    "54035": 2,
    "54037": 2,
    "54039": 3,
    "54041": 1,
    "54043": 2,
    "54045": 1,
    "54047": 1,
    "54049": 2,
    "54051": 1,
    "54053": 2,
    "54055": 2,
    "54057": 3,
    "54059": 2,
    "54061": 2,
    "54063": 0,
    "54065": 1,
    "54067": 2,
    "54069": 1,
    "54071": 2,
    "54073": 1,
    "54075": 1,
    "54077": 3,
    "54079": 2,
    "54081": 2,
    "54083": 1,
    "54085": 1,
    "54087": 1,
    "54089": 0,
    "54091": 2,
    "54093": 1,
    "54095": 1,
    "54097": 2,
    "54099": 3,
    "54101": 1,
    "54103": 1,
    "54105": 1,
    "54107": 3,
    "54109": 1,
    "55001": 2,
    "55003": 2,
    "55005": 2,
    "55007": 1,
    "55009": 2,
    "55011": 2,
    "55013": 2,
    "55015": 2,
    "55017": 1,
    "55019": 2,
    "55021": 3,
    "55023": 2,
    "55025": 4,
    "55027": 4,
    "55029": 2,
    "55031": 2,
    "55033": 2,
    "55035": 1,
    "55037": 1,
    "55039": 4,
    "55041": 2,
    "55043": 3,
    "55045": 3,
    "55047": 3,
    "55049": 3,
    "55051": 2,
    "55053": 2,
    "55055": 3,
    "55057": 2,
    "55059": 2,
    "55061": 0,
    "55063": 2,
    "55065": 3,
    "55067": 2,
    "55069": 2,
    "55071": 2,
    "55073": 3,
    "55075": 2,
    "55077": 3,
    "55078": 2,
    "55079": 2,
    "55081": 3,
    "55083": 1,
    "55085": 2,
    "55087": 3,
    "55089": 2,
    "55091": 2,
    "55093": 2,
    "55095": 2,
    "55097": 2,
    "55099": 2,
    "55101": 3,
    "55103": 1,
    "55105": 3,
    "55107": 2,
    "55109": 2,
    "55111": 3,
    "55113": 1,
    "55115": 2,
    "55117": 2,
    "55119": 2,
    "55121": 2,
    "55123": 3,
    "55125": 1,
    "55127": 3,
    "55129": 1,
    "55131": 2,
    "55133": 3,
    "55135": 3,
    "55137": 2,
    "55139": 2,
    "55141": 2,
    "56001": 5,
    "56003": 1,
    "56005": 4,
    "56007": 4,
    "56009": 2,
    "56011": 3,
    "56013": 4,
    "56015": 3,
    "56017": 2,
    "56019": 2,
    "56021": 5,
    "56023": 2,
    "56025": 3,
    "56027": 1,
    "56029": 2,
    "56031": 3,
    "56033": 1,
    "56035": 2,
    "56037": 2,
    "56039": 1,
    "56041": 0,
    "56043": 1,
    "56045": 2
  };

  export { danger_bins };